import ActionMenu, {
  ActionMenuItem,
} from "../../../../../components/actionMenu/ActionMenu";

import { useAppDispatch } from "../../../../../redux/hooks";
import { AssignedDriverDataInterface } from "../../../../../redux/interfaces/transport.interface";
import { fetchDeactivateOrActivateRoute } from "../../../../../redux/api/transport.api";
import { setAssignDriver } from "../../../../../redux/reducer/transport.reducer";
import { useNavigate } from "react-router-dom";
import { transportRoutes } from "../../../../../router/routesConstants";

function AssignDriverActionButton({
  itemId,
  crudData,
}: {
  itemId: string;
  crudData: AssignedDriverDataInterface;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isActive = crudData.status == 1;
  const hasRoute = Boolean(crudData.id_ruta || crudData.id_ruta_intranod);

  const handleCopyDriver = () => {
    dispatch(setAssignDriver(crudData));
    navigate(transportRoutes.assignDriver);
  };

  const handleCopyDriverRoutes = () => {
    if (!isActive) return;
    dispatch(setAssignDriver(crudData));
    navigate(transportRoutes.copyDriverRoutes);
  };

  const handleDeactivateDriver = () => {
    if (!isActive || !hasRoute) return;
    dispatch(
      fetchDeactivateOrActivateRoute({
        id_sofer_rute: itemId,
        activ: 2,
      }),
    );
  };

  const items: ActionMenuItem[] = [
    {
      id: "copy-route",
      label: "Copiaza ruta",
      icon: "COPY",
      section: "manage",
      tooltip: "Copiaza configuratia rutei acestui sofer.",
      onClick: handleCopyDriver,
    },
    {
      id: "assign-driver",
      label: "Aloca nou sofer pe ruta",
      icon: "ASSIGN_DRIVER",
      section: "manage",
      tooltip: isActive
        ? "Deschide alocarea unui nou sofer pe aceasta ruta."
        : "Ruta trebuie sa fie activa pentru a aloca un nou sofer.",
      disabled: !isActive,
      onClick: handleCopyDriverRoutes,
    },
    {
      id: "deactivate-route",
      label: "Dezactiveaza alocarea rutei",
      icon: "CLOSE_ICON",
      color: "error",
      section: "danger",
      tooltip: !isActive
        ? "Alocarea este deja inactiva."
        : !hasRoute
        ? "Nu exista o ruta alocata de dezactivat."
        : "Dezactiveaza alocarea acestei rute dupa confirmare.",
      disabled: !isActive || !hasRoute,
      withConfirmationModal: {
        modalTitle: "Doriti sa dezactivati alocarea pe aceasta ruta?",
        modalSubtitle: `${crudData.nume} ${crudData.prenume} -> ${
          crudData.ruta || crudData.intranod
        }`,
        modalRightButtonText: "Da",
        modalLeftButtonText: "Nu",
        modalRightButtonOnClick: handleDeactivateDriver,
      },
    },
  ];

  return (
    <ActionMenu
      items={items}
      title={`${crudData.nume} ${crudData.prenume}`}
      ariaLabel={`Actiuni pentru soferul ${crudData.nume} ${crudData.prenume}`}
    />
  );
}

export default AssignDriverActionButton;
